export const externalApiPermissions = {
  pageId: 72,
  name: 'External API Clients',
  path: '/external-api',
  sections: {},
} as const;
